import { post } from './utils'

interface OrderExtra {
  orderNo: string,
  extraId?: string
}
export const getFragranceItems = async (
  orders: OrderExtra[]
): Promise<any> => {
  try {
    const path = '/report/fragrance-items';
    const fragranceResult = await post(path, {
      "PD_ORDERS": orders
    })
    return fragranceResult
  } catch (error: any) {
    return {
      success: false,
      message: error.response ? error.response.data.message : 'Error from API, Please contact administrator.'
    }
  }
}